import React, { useEffect, useState } from "react";
import { Dialog, Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom"; // ✅ ADD THIS
import events from "../../data/events";
import event1 from "../../assets/images/eventt1.jpg";

const EventPopup = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate(); // ✅ INIT NAVIGATE

  useEffect(() => {
    const isClosed = sessionStorage.getItem("eventPopupClosed");
    if (!isClosed) {
      setOpen(true);
    }
  }, []);

  const handleClose = () => {
    sessionStorage.setItem("eventPopupClosed", "true");
    setOpen(false);
  };

  // ✅ NEW FUNCTION
  const handleViewDetails = (id) => {
    console.log("Clicked ID:", id); // 👈 DEBUG

    sessionStorage.setItem("eventPopupClosed", "true");
    setOpen(false);

    navigate(`/events/${id}`);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          overflow: "hidden",
          width: { xs: "95%", sm: "500px", md: "600px" }, // ✅ fixed
          m: { xs: 1, sm: 2 },
        },
      }}
    >
      {/* Close Button */}
      <IconButton
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 10,
          top: 10,
          zIndex: 2,
          background: "#fff",
          "&:hover": { background: "#eee" },
        }}
      >
        <CloseIcon />
      </IconButton>

      {/* ✅ IMAGE SECTION (NO CROP + RESPONSIVE) */}
      <Box
        sx={{
          width: "100%",
          aspectRatio: "4/3", // ✅ key fix (auto height, no white space)
          overflow: "hidden",
        }}
      >
        <Box
          component="img"
          src={event1}
          alt="Event Banner"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover", // ✅ fills completely
            objectPosition: "center", // ✅ keeps focus centered
            display: "block",
          }}
        />
      </Box>

      {/* Content */}
      <Box sx={{ p: { xs: 2, sm: 3 } }}>
        <Typography
          variant="h6"
          fontWeight="bold"
          gutterBottom
          sx={{
            fontSize: { xs: "16px", sm: "20px", md: "22px" },
            pr: 4,
          }}
        >
          THE BIG MEDIA RESET
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            mb: 2,
            fontSize: { xs: "13px", sm: "14px" },
          }}
        >
          Unveiling findings from India's first post-COVID, single-source media
          study, revealing how audiences consume media...
        </Typography>

        <Typography
          variant="body2"
          sx={{
            mb: 3,
            fontSize: { xs: "13px", sm: "14px" },
          }}
        >
          • 12K Consumers • 10 Markets • 5+ Media Channels • 1 Source
        </Typography>

        {/* ✅ FIXED BUTTON (single instead of map) */}
        <Button
          fullWidth
          variant="contained"
          onClick={() => handleViewDetails(events[0]?.id)}
          sx={{
            backgroundColor: "#e86c2c",
            borderRadius: "10px",
            py: { xs: 1.2, sm: 1.5 },
            fontSize: { xs: "14px", sm: "16px" },
            fontWeight: 600,
            "&:hover": {
              backgroundColor: "#d65b1f",
            },
          }}
        >
          View Details →
        </Button>
      </Box>
    </Dialog>
  );
};

export default EventPopup;
